// validators.ts
import { AbstractControl, ValidationErrors } from '@angular/forms';

export function maxPlainTextLength(maxLength: number) {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;

        const div = document.createElement('div');
        div.innerHTML = control.value;
        const text = div.innerText || div.textContent || '';

        return text.length > maxLength ? { maxlengthText: true } : null;
    };
}
